import { useEffect } from "react";

import { TableColumnMeta } from "ds/components/Table/types";

import { STICKY_ACTION_COLUMN_MAX_WIDTH } from "../../constants";
import { TableColumnsState } from "../../hooks/useTableStore/types";

const STICKY_COLUMN_MAX_WIDTH_PERCENT = 0.8;

export const useColumnWidth = (
  column: TableColumnMeta,
  columnSizes: TableColumnsState["columnsSizes"],
  setColumnSize: TableColumnsState["setColumnSize"],
  stickyLeft?: boolean,
  tableWidth?: number
) => {
  const savedColumnWidth = columnSizes[column.id];

  const effectiveTableWidth = tableWidth && Math.floor(tableWidth - STICKY_ACTION_COLUMN_MAX_WIDTH);

  const effectiveMaxWidth =
    stickyLeft && effectiveTableWidth
      ? Math.floor(effectiveTableWidth * STICKY_COLUMN_MAX_WIDTH_PERCENT)
      : column.maxWidth;

  // Auto-adjust column width if it exceeds the new table width constraints
  useEffect(() => {
    if (stickyLeft && tableWidth && savedColumnWidth > effectiveMaxWidth) {
      setColumnSize(column.id, effectiveMaxWidth);
    }
  }, [stickyLeft, tableWidth, savedColumnWidth, effectiveMaxWidth, setColumnSize, column.id]);

  return {
    savedColumnWidth,
    effectiveMaxWidth,
  };
};
